import {
    SET_EMPLOYEE_INFO,
    SET_EMPLOYEE_ID_ERROR,
    SET_EMPLOYEE_REASON_INFO
} from "./EmployeeInfoType";

const initialState = {
    employeeInfo: {},
    employeeInfoError: "",
    employeeReasonInfo: {}
}

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_EMPLOYEE_INFO:
            return {
                ...state,
                employeeInfo: action.employeeInfo,
            };
        case SET_EMPLOYEE_ID_ERROR:
            return {
                ...state,
                employeeInfoError: action.error,
            };
        case SET_EMPLOYEE_REASON_INFO:
            return {
                ...state,
                employeeReasonInfo: action.reasonInfo,
            };
        default:
            return state;
    }
};

export { 
    reducers
 };